  document.addEventListener("DOMContentLoaded", function () {

    const swiper = new Swiper('.testimonial-rev', {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.5,
    spaceBetween: 16,
    pagination: {
      el: '.review-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1.5,
        centeredSlides: true
      },
      1024: {
        slidesPerView: 2.80,
        centeredSlides: true
      }
    }
  });

   new Swiper('.images-items', {
   slidesPerView: 2.5,
   spaceBetween: 16,
   loop: true,
   breakpoints: {
    640: { slidesPerView: 2.5 },
    1024: { slidesPerView: 4.6 },
  }
 });

  new Swiper('.our-kitchen-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 30,
  loop: true,

  freeMode: false,

  pagination: {
    el: '.kitchen-pagination',
    clickable: true,
  },

  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 'auto',
    hide: false,
  },

  allowTouchMove: true,
  simulateTouch: true,
  grabCursor: true,
  followFinger: true,
  threshold: 10,   
  touchAngle: 45,

  mousewheel: {
    forceToAxis: true,
    sensitivity: 0.3,  
    releaseOnEdges: true,
  },

  breakpoints: {
    640: { slidesPerView: 1.2 },
    1024: { slidesPerView: 3 },
    1140: { slidesPerView: 3.5 },
    1280: { slidesPerView: 4 },
  },
});

    
    const tabs = document.querySelectorAll(".tab-links button");
    const contents = document.querySelectorAll(".tab-content");

    tabs.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        tabs.forEach(b => b.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));
        btn.classList.add("active");
        contents[i].classList.add("active");
      });
    });
    
  });



window.addEventListener('load', function () {
  const slider = document.querySelector('.slider-mobile-gutter');
  const topings = document.querySelector('.topings');

  if (slider && topings) {
    const height = slider.offsetHeight;
    topings.style.height = height + 'px';
  }
});